module.exports = __webpack_public_path__ + "img/pdfFile.8f56e7b6.png";